import React, { useState, useEffect, useContext, createContext } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useRemote, useStorage } from '../../../Utils/Utils';
import { PAGES, ROUTE_PATHS, BannerContext } from '../../../InternalApiApp';
import Page, { PageContentBodyGrid } from '../../Shared/Page/Page';
import PageGridItem from '../../Shared/Page/PageGridItem';
import PageGridDivider from '../../Shared/Page/PageGridDivider';
import withRouteChange from "@threeskye/route-change";
import ActionButtonsBanner from '../../Shared/Banner/ActionButtonsBanner';
import LoadingIcon from '../../Shared/LoadingIcon';
import PageContentToggle from '../../../components/Menus/PageContentToggle';
import SchemeGeneral from './SchemeTabs/SchemeGeneral';
import { Route, Switch } from 'react-router-dom';

export const SchemeContext = createContext();


const SchemePage = ({ portfolio }) => {
    const { setBannerBreadCrumbs } = useContext(BannerContext);
    const { schemeId } = useParams()
    const remote = useRemote()
    const storage = useStorage()
    const history = useHistory()

    const [originalScheme, setOriginalScheme] = useState(null)
    const [scheme, setScheme] = useState(null)  // scheme with current edits
    const [editMode, setEditMode] = useState(false)
    const [searchTerm, setSearchTerm] = useState("")
    const [list, setList] = useState([])
    const [loading, setLoading] = useState(true)
    const [selectedTab, setSelectedTab] = useState("General")
    const linkStem = portfolio ? `${ROUTE_PATHS[PAGES.ADMIN]}/portfolio-management/platforms/${schemeId}` : `${ROUTE_PATHS[PAGES.ADMIN]}/fund-management/scheme/${schemeId}`


    useEffect(() => {
        remote.get(`/funds/schemes/${schemeId}`).then((scheme) => {
            setBannerBreadCrumbs({ tab: portfolio ? 'Platforms' : "Schemes", param1: { name: scheme.schemeName, id: schemeId } })
            storage.getOrFetch(`funds/offers`).then(offers => {
                const filteredOffers = offers.filter(o => o.schemeNumber === schemeId)
                setList(filteredOffers)
                setOriginalScheme(scheme)
                setScheme(scheme)
            }).then(() => setLoading(false))
        });
    }, [remote, schemeId])

    function saveEdits() {
        remote.post(`/funds/schemes/${schemeId}`, scheme).then((scheme) => {
            setOriginalScheme(scheme)
            setScheme(scheme)
        })
        setEditMode(false)
    }

    function cancelEdits() {
        setScheme(originalScheme)
        setEditMode(false)
    }

    function updateScheme(newValue, property) {
        // save temporary updates
        const newObj = { ...scheme, [property]: newValue }
        setScheme(newObj)
    }

    function changeTab(string) {
        if (string === "General") {
            return history.push(linkStem + ``)
        } else if (string === "Footnotes") {
            return history.push(linkStem + `/footnotes`)
        }
    }

    const labels = [
        { label: "General", active: selectedTab === "General", onClick: () => changeTab("General") },
    ]

    if (loading) return (
        <Page noBanner>
            <PageContentBodyGrid rowGap="none" gridColCount="12" subGrid paddingBottom="2.5rem">
                <PageGridItem gap='l' direction='col' col="1 / span 12" >
                    <ActionButtonsBanner
                        className="pt-l"
                        hideBackButton
                        editMode={editMode}
                        edit={{ onClick: () => setEditMode(true) }}
                        duplicate={{ disabled: true }}
                        remove={{ disabled: true }}
                        cancel={{ onClick: () => { cancelEdits() } }}
                        save={{ onClick: () => { saveEdits() } }}
                    />
                    <PageGridDivider />
                </PageGridItem>
                <PageGridItem container col="1 / span 6" direction='col' gap="xl" style={{ display: 'flex', paddingRight: '1.5rem' }}>
                    <PageContentBodyGrid rowGap="xl" gridColCount="6" subGrid>
                        <LoadingIcon centered />
                    </PageContentBodyGrid>
                </PageGridItem>
            </PageContentBodyGrid>
        </Page>

    )

    return (
        <Page noBanner>
            <PageContentBodyGrid rowGap="none" gridColCount="12" subGrid paddingBottom="2.5rem">
                <PageGridItem gap='l' direction='col' col="1 / span 12" >
                    <ActionButtonsBanner
                        className="pt-l"
                        hideBackButton
                        editMode={editMode}
                        edit={{ onClick: () => setEditMode(true) }}
                        duplicate={{ disabled: true }}
                        remove={{ disabled: true }}
                        cancel={{ onClick: () => { cancelEdits() } }}
                        save={{ onClick: () => { saveEdits() } }}
                    />
                    <PageGridDivider />
                </PageGridItem>
                <PageGridItem gap='m' direction='col' col="1 / span 12" className="mt-m" >
                    <PageContentToggle style={{ overflowX: 'auto', scrollbarWidth: 'none' }} labels={labels} />
                    <PageGridDivider />
                </PageGridItem>
                <PageGridItem gap='m' direction='col' col="1 / span 12" className="pt-l" >
                    <PageContentBodyGrid subGrid>
                        <SchemeContext.Provider
                            value={{
                                originalScheme,
                                setOriginalScheme,
                                scheme,
                                setScheme,
                                editMode,
                                setEditMode,
                                searchTerm,
                                setSearchTerm,
                                list,
                                setList,
                                loading,
                                setLoading,
                                updateScheme
                            }}
                        >
                            <Switch >
                                <Route exact path={ROUTE_PATHS[PAGES.ADMIN] + `/portfolio-management/platforms/:schemeId`} render={() => <SchemeGeneral portfolio />} />
                                <Route exact path={ROUTE_PATHS[PAGES.ADMIN] + `/fund-management/schemes/:schemeId`} render={() => <SchemeGeneral />} />
                            </Switch>
                        </SchemeContext.Provider>
                    </PageContentBodyGrid>
                </PageGridItem>
            </PageContentBodyGrid>
        </Page>
    );
}

export default withRouteChange(SchemePage);